export default "__VITE_ASSET__d83ddf4e__"